import { media, styled } from '@pulse-web-ui/theme';

import { PromoCode } from '@src/features';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${media.desktop} {
    flex-direction: row;
  }
`;

export const StyledPromoCode = styled(PromoCode)`
  margin-top: 24px;

  ${media.desktop} {
    margin: 0 0 0 10px;
  }
`;
